import React from "react";
import "./IDCardinfo.scss";
import axios from "axios";
import {
  Toast,
  InputItem,
  TextareaItem,
  Button,
  DatePicker,
  List
} from "antd-mobile";
import scan from "./test-scan.svg";
import moment from "moment";
import http from "../../util/api";

/**
 *
 * @param {*} file
 * @param {*} url
 * @param {*} mode
 */
const uploadFile = (file, url, mode) => {
  return new Promise((resolve, reject) => {
    let fd = new FormData();
    fd.append("file", file, file.name);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.onload = () => {
      const data = JSON.parse(xhr.response);
      if (xhr.status === 200 && (data.error === 0 || data.error === "0")) {
        let imgUrl;
        if (mode === "local") {
          imgUrl = data.httpfilename;
        } else if (mode === "cloud") {
          imgUrl = data.data;
        }
        resolve(imgUrl);
      } else {
        reject(data);
      }
    };
    xhr.send(fd);
  });
};
/**
 * 压缩图片
 * @param file input获取到的文件
 * @param callback 回调函数，压缩完要做的事，例如ajax请求等。
 */
function compressFile(file, callback) {
  const originFileName = file.name;
  const originFileType = file.type;
  let fileObj = file;
  let reader = new FileReader();
  reader.readAsDataURL(fileObj); //转base64
  reader.onload = function(e) {
    let image = new Image(); //新建一个img标签（还没嵌入DOM节点)
    image.src = e.target.result;
    image.onload = function() {
      const originWidth = this.width;
      const originHeight = this.height;
      // 最大尺寸限制
      const maxWidth = 400,
        maxHeight = 400;
      // 目标尺寸
      let targetWidth = originWidth,
        targetHeight = originHeight;
      // 图片尺寸超过400x400的限制
      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          // 更宽，按照宽度限定尺寸
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
      let canvas = document.createElement("canvas"), // 新建canvas
        context = canvas.getContext("2d"),
        data = "";
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.drawImage(image, 0, 0, targetWidth, targetHeight);
      data = canvas.toDataURL("image/jpeg"); // 输出压缩后的base64
      let arr = data.split(","),
        mime = arr[0].match(/:(.*?);/)[1], // 转成blob
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let files = new window.File(
        [new Blob([u8arr], { type: mime })],
        originFileName,
        { type: originFileType }
      ); // 转成file
      callback(files); // 回调
    };
  };
}

const minDate = new Date(1900, 1, 1, 0, 0, 0);
const resid = "617650212793"; //人员信息表

class IDCardinfo extends React.Component {
  state = {
    words_result: {},
    name: "",
    sex: "",
    nation: "",
    birthday: "",
    cardnumber: "",
    address: "",
    personinfo: {},
    positionid: ""
  };
  componentDidMount() {
    const locationState = this.props.location.state;
    if (locationState && locationState.data) {
      this.setState({
        personinfo: locationState.data,
        positionid: locationState.id
      });
    }
  }

  handleSubmit = async () => {
    const {
      name,
      sex,
      nation,
      birthday,
      cardnumber,
      address,
      personinfo,
      positionid
    } = this.state;
    const { history } = this.props;
    personinfo.name1 = name;
    personinfo.sex1 = sex;
    personinfo.birthdate1 = birthday;
    personinfo.ID1 = cardnumber;
    personinfo.naition1 = nation;
    personinfo.site1 = address;
    personinfo.C3_634998559348 = "Y";
    Toast.loading("提交中...", 0);
    try {
      await http().modifyRecords({
        resid,
        data: [personinfo]
      });
      Toast.hide();
      //问卷编号不为空则需要填写问卷
      if (personinfo.C3_634998579750) {
        history.push({
          pathname: "/virus-questions/" + personinfo.C3_634998579750,
          state: { data: personinfo, id: positionid }
        });
      } else {
        history.push("/appointment_position/" + positionid);
      }
    } catch (error) {
      console.error(error);
      Toast.fail(error.message);
    }
  };
  render() {
    const { name, sex, nation, birthday, cardnumber, address } = this.state;
    const enable = name && sex && nation && cardnumber && address;
    return (
      <div className="idcardinfo">
        <div className="scan-idcard">
          <img
            src={scan}
            alt=""
            style={{ height: 20, width: 20, marginRight: 12 }}
          />
          扫描身份证自动填入信息
          <input
            ref={e => {
              this.fileinputref = e;
            }}
            type="file"
            onChange={async () => {
              let file = this.fileinputref.files[0];
              if (file) {
                const type = file.type.split("/");
                Toast.loading("识别身份证信息中...", 0);
                try {
                  return compressFile(file, async files => {
                    const res = await uploadFile(
                      files,
                      "http://kingofdinner.realsun.me:1201/api/AliyunOss/PutOneImageObject?bucketname=nutritiontower&srctype=" +
                        type[1],
                      "cloud"
                    );
                    const response = await axios.get(
                      "http://kingofdinner.realsun.me:1201/api/Baidu/OCR/OcrIDCardByUrlImage?url=" +
                        res
                    );
                    Toast.hide();
                    if (response.data.data.idcard_number_type === 1) {
                      const words_result = response.data.data.words_result;
                      const birthday = moment(words_result.出生.words).toDate();
                      this.setState({
                        name: words_result.姓名.words,
                        sex: words_result.性别.words,
                        nation: words_result.民族.words,
                        cardnumber: words_result.公民身份号码.words,
                        address: words_result.住址.words,
                        birthday
                      });
                      Toast.hide();
                    } else {
                      alert("无法识别身份证信，请重试");
                      Toast.hide();
                    }
                  });
                } catch (error) {
                  Toast.fail(error.message);
                }
              }
            }}
            onSelect={() => {}}
            accept="image/*"
            // capture="camera"
          />
        </div>
        <InputItem
          placeholder="请输入"
          value={name}
          onChange={v => this.setState({ name: v })}
        >
          姓名：
        </InputItem>
        <InputItem
          placeholder="请输入"
          value={sex}
          onChange={v => this.setState({ sex: v })}
        >
          性别：
        </InputItem>
        <InputItem
          placeholder="请输入"
          value={nation}
          onChange={v => this.setState({ nation: v })}
        >
          民族：
        </InputItem>
        <DatePicker
          placeholder="请输入"
          mode="date"
          value={birthday}
          onChange={v => this.setState({ birthday: v })}
          minDate={minDate}
        >
          <List.Item arrow="horizontal">出生年月：</List.Item>
        </DatePicker>
        <InputItem
          placeholder="请输入"
          value={cardnumber}
          onChange={v => this.setState({ cardnumber: v })}
        >
          身份证号：
        </InputItem>
        <div style={{ fontSize: 17, paddingTop: 10, padding: "15px" }}>
          <label>户籍地址：</label>
          <TextareaItem
            rows="4"
            placeholder="请输入"
            value={address}
            onChange={v => this.setState({ address: v })}
          />
        </div>
        <div className="idcardinfo__footer">
          <Button disabled={!enable} type="primary" onClick={this.handleSubmit}>
            下一步
          </Button>
        </div>
      </div>
    );
  }
}
export default IDCardinfo;
